export default "__VITE_ASSET__DLGs8IcK__"